import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID, RendererFactory2, DOCUMENT } from '@angular/core';
import { AccessibilityModule, AccessibilityModuleConfigs } from '../accessibility-module.interfaces';
import * as i0 from "@angular/core";
export let AccessibilityColorBlindnessFilterHandler = /*#__PURE__*/(() => {
  class AccessibilityColorBlindnessFilterHandler {
    constructor() {
      this.doc = inject(DOCUMENT);
      this.renderer = inject(RendererFactory2).createRenderer(null, null);
      this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
      if (this.isBrowser) {
        const svgNamespace = 'http://www.w3.org/2000/svg';
        this.svg = this.doc.createElementNS(svgNamespace, 'svg');
        this.svg.setAttribute('width', '0');
        this.svg.setAttribute('height', '0');
        this.svg.setAttribute('version', '1.1');
        this.svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svg.id = 'a11y-color-blindness-filter-svg';
        this.defs = this.doc.createElementNS(svgNamespace, 'defs');
        this.filter = this.doc.createElementNS(svgNamespace, 'filter');
        this.filter.id = 'colorblindnessfilter';
        this.filter.setAttribute('color-interpolation', 'linearRGB');
        this.filter.setAttribute('x', '0%');
        this.filter.setAttribute('y', '0%');
        this.filter.setAttribute('width', '100%');
        this.filter.setAttribute('height', '100%');
        this.matrix = this.doc.createElementNS(svgNamespace, 'feColorMatrix');
        this.matrix.id = 'colorblindnessmatrix';
        this.matrix.setAttribute('type', 'matrix');
        this.renderer.appendChild(this.filter, this.matrix);
        this.renderer.appendChild(this.defs, this.filter);
        this.renderer.appendChild(this.svg, this.defs);
      }
    }
    getTransformationMatrixString(type) {
      switch (type) {
        case 'red':
          // Protanomalie
          return '1 0 0 0 0 ' + '0.48 0.48 0.05 0 0 ' + '0.6 -0.7 1.1 0 0 ' + '0 0 0 1 0';
          break;
        case 'green':
          // Deuteranomalie
          return '1.45 -0.65 0.2 0 0 ' + '0 1 0 0 0 ' + '-0.2 0.19 1 0 0 ' + '0 0 0 1 0';
          break;
        case 'blue':
          // Tritanomalie
          return '0.75 -0.4 0.66 0 0 ' + '0.075 0.58 0.34 0 0 ' + '0 0 1 0 0 ' + '0 0 0 1 0';
          break;
        case 'none':
          // Tritanomalie
          return '1 0 0 0 0 ' + '0 1 0 0 0 ' + '0 0 1 0 0 ' + '0 0 0 1 0';
          break;
      }
    }
    stringToMatrix(data) {
      const matrix = Array.isArray(data) ? data : data.split(' ').map(v => parseFloat(v));
      if (matrix.length !== 20) throw new Error('transformation matrix has unexpected count of values!');
      return matrix;
    }
    scaleTransformationMatrix(data, intensity) {
      const matrix = this.stringToMatrix(data);
      const nullMatrix = this.stringToMatrix(this.getTransformationMatrixString('none'));
      const scaledMatrix = matrix.map((maxValue, index) => {
        const minValue = nullMatrix[index];
        return maxValue * intensity + minValue * (1 - intensity);
      });
      return scaledMatrix.join(' ');
    }
    onUpdate(enabled, config) {
      if (this.isBrowser) {
        if (enabled && config.intensity > 0.0 && config.type) {
          this.renderer.appendChild(this.doc.body, this.svg);
          const baseMatrix = this.getTransformationMatrixString(config.type);
          const scaledMatrix = this.scaleTransformationMatrix(baseMatrix, config.intensity);
          this.matrix.setAttribute('values', scaledMatrix);
          this.renderer.setStyle(this.doc.documentElement, 'filter', "url(#colorblindnessfilter)");
          this.renderer.setStyle(this.doc.body, 'filter', "url(#colorblindnessfilter)");
        } else {
          this.renderer.removeStyle(this.doc.documentElement, 'filter');
          this.renderer.removeChild(this.doc.body, this.svg);
        }
      }
    }
    static {
      this.ɵfac = function AccessibilityColorBlindnessFilterHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityColorBlindnessFilterHandler)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessibilityColorBlindnessFilterHandler,
        factory: AccessibilityColorBlindnessFilterHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessibilityColorBlindnessFilterHandler;
})();